var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 4.12203L10.9243 3.01653C8.39984 0.421527 3.77084 1.31703 2.09984 4.57953C1.31534 6.11403 1.13834 8.32953 2.57084 11.157C3.95084 13.8795 6.82184 17.1405 11.9998 20.6925C17.1778 17.1405 20.0473 13.8795 21.4288 11.157C22.8613 8.32803 22.6858 6.11403 21.8998 4.57953C20.2288 1.31703 15.5998 0.420027 13.0753 3.01503L11.9998 4.12203ZM11.9998 22.5C-10.9997 7.30203 4.91834 -4.55997 11.7358 1.71453C11.8258 1.79703 11.9143 1.88253 11.9998 1.97103C12.0845 1.88261 12.1725 1.79754 12.2638 1.71603C19.0798 -4.56297 34.9993 7.30053 11.9998 22.5Z",
    fill: "#004A96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1cb76470.svg";
export { ForwardRef as ReactComponent };